export var PUSH_REQUEST_CLOSED_COUNT = 'pushRequestClosedCount';
export var PUSH_REQUEST_CLOSED_TIMESTAMP = 'pushRequestClosedTimestamp';
export var MAX_CLOSE_COUNT = 3;
export var ONE_DAY_IN_MINUTES = 60 * 24;